import { render } from "./form.vue?vue&type=template&id=583d255c&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=583d255c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ssp-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583d255c"]])

export default __exports__